module.exports = __webpack_public_path__ + "static/media/photo45.5a5695f5.jpg";